'use strict';

var md5 = require('md5');
var StackTrace = require('stacktrace-js');
var axios = require('axios');
var dayjs = require('dayjs');
var prettyFormat = require('@permafrost-dev/pretty-format');
var uuid = require('uuid');
var stopwatchNode = require('stopwatch-node');
var formatXml = require('xml-formatter');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var PACKAGE_VERSION = '1.19.4';

var Payload = (function () {
    function Payload() {
        this.remotePath = null;
        this.localPath = null;
        this.initialized = false;
        this.data = {
            type: '',
            content: '',
            origin: { function_name: '', file: '', line_number: 0, hostname: 'remote' },
        };
    }
    Payload.prototype.replaceRemotePathWithLocalPath = function (filePath) {
        if (this.remotePath === null || this.localPath === null) {
            return filePath;
        }
        var pattern = new RegExp('^' + this.remotePath);
        return filePath.replace(pattern, this.localPath);
    };
    Payload.prototype.getContent = function () {
        return {};
    };
    Payload.prototype.toArray = function () {
        if (!this.initialized) {
            this.initialized = true;
            this.data.type = this.getType();
            this.data.content = this.getContent();
            this.data.origin.file = this.replaceRemotePathWithLocalPath(this.data.origin.file);
        }
        return this.data;
    };
    Payload.prototype.toJson = function () {
        return JSON.stringify(this.toArray());
    };
    return Payload;
}());

var ClearAllPayload = (function (_super) {
    __extends(ClearAllPayload, _super);
    function ClearAllPayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClearAllPayload.prototype.getType = function () {
        return 'clear_all';
    };
    return ClearAllPayload;
}(Payload));

var Client = (function () {
    function Client(portNumber, host, scheme) {
        if (portNumber === void 0) { portNumber = 23517; }
        if (host === void 0) { host = 'localhost'; }
        if (scheme === void 0) { scheme = 'http'; }
        this.scheme = 'http';
        this.portNumber = portNumber;
        this.host = host;
        this.scheme = scheme;
    }
    Client.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.updateRayAvailabilty()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Client.prototype.isRayAvailable = function () {
        this.attemptAvailableReset();
        if (Client.rayState === null) {
            this.updateRayAvailabilty();
        }
        if (Client.rayState !== null) {
            return Client.rayState;
        }
        return true;
    };
    Client.prototype.attemptAvailableReset = function () {
        if (Client.lastRayStateCheck !== null && new Date().getTime() - Client.lastRayStateCheck >= 30000) {
            Client.rayState = null;
        }
    };
    Client.prototype.updateRayAvailabilty = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = true;
                        if (Client.lastRayStateCheck !== null && new Date().getTime() - Client.lastRayStateCheck < 30000) {
                            return [2, true];
                        }
                        Client.lastRayStateCheck = new Date().getTime();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, axios.get(this.getUrlForPath('/locks/__availabilty_check'), {})];
                    case 2:
                        _a.sent();
                        return [3, 5];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1.response) {
                            result = true;
                        }
                        else if (err_1.request) {
                            result = false;
                        }
                        else {
                            result = false;
                        }
                        return [3, 5];
                    case 4:
                        Client.rayState = result;
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    Client.prototype.getUrlForPath = function (path) {
        var _a;
        path = path.replace(/^\//, '');
        return "".concat((_a = this.scheme) !== null && _a !== void 0 ? _a : 'http', "://").concat(this.host, ":").concat(this.portNumber, "/").concat(path);
    };
    Client.prototype.send = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Client.rayState === null || Client.lastRayStateCheck === null) {
                            this.updateRayAvailabilty();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        request.payloads = this.ensureAllPayloadsHaveAnOrigin(request.payloads);
                        return [4, axios.post(this.getUrlForPath('/'), request.toArray(), { withCredentials: false })];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        _a.sent();
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    Client.prototype.ensureAllPayloadsHaveAnOrigin = function (payloads) {
        payloads.forEach(function (payload) {
            if (payload.data.origin.file === null ||
                payload.data.origin.file === '' ||
                typeof payload.data.origin['file'] === 'undefined') {
                payload.data.origin['file'] = '/unknown-file.js';
                payload.data.origin['line_number'] = 1;
                payload.data.origin['function_name'] = 'unknown';
            }
        });
        return payloads;
    };
    Client.prototype.lockExists = function (lockName) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var resp;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4, axios.get(this.getUrlForPath("/locks/".concat(lockName)))];
                                case 1:
                                    resp = _a.sent();
                                    return [3, 3];
                                case 2:
                                    _a.sent();
                                    return [2, false];
                                case 3:
                                    if (resp.data.stop_execution) {
                                        reject(new Error('stopping execution'));
                                        return [2];
                                    }
                                    if (typeof resp.data['active'] === 'undefined') {
                                        resolve(resp.data);
                                        return [2];
                                    }
                                    resolve(resp.data);
                                    return [2];
                            }
                        });
                    }); })];
            });
        });
    };
    Client.rayState = true;
    Client.lastRayStateCheck = null;
    return Client;
}());

var RemovesRayFrames = (function () {
    function RemovesRayFrames() {
    }
    RemovesRayFrames.removeRayFrames = function (frames) {
        var result = frames.filter(function (frame) { return !RemovesRayFrames.isRayFrame(frame) && !RemovesRayFrames.isNodeFrame(frame); });
        return result;
    };
    RemovesRayFrames.isRayFrame = function (frame) {
        var _a;
        for (var _i = 0, _b = this.rayNamespaces(); _i < _b.length; _i++) {
            var rayNamespace = _b[_i];
            if ((_a = frame.fileName) === null || _a === void 0 ? void 0 : _a.includes(rayNamespace)) {
                return true;
            }
        }
        return false;
    };
    RemovesRayFrames.isNodeFrame = function (frame) {
        var _a;
        return ((_a = frame.fileName) === null || _a === void 0 ? void 0 : _a.indexOf('node:')) === 0;
    };
    RemovesRayFrames.rayNamespaces = function () {
        return ['ray-node/dist', 'node-ray/dist', 'vue-ray/dist'];
    };
    return RemovesRayFrames;
}());

var CallerPayload = (function (_super) {
    __extends(CallerPayload, _super);
    function CallerPayload(frames) {
        var _this = _super.call(this) || this;
        _this.frames = RemovesRayFrames.removeRayFrames(frames);
        return _this;
    }
    CallerPayload.prototype.getType = function () {
        return 'caller';
    };
    CallerPayload.prototype.getContent = function () {
        var frames = this.frames.slice(0);
        var frame = frames[0];
        var funcNameParts = frame.getFunctionName().replace('Proxy.', '').split('.').slice(0);
        var className = funcNameParts.length ? funcNameParts.shift() : '';
        var methodName = funcNameParts.join('.');
        return {
            frame: {
                file_name: this.replaceRemotePathWithLocalPath(frame.getFileName()),
                line_number: frame.getLineNumber(),
                class: className,
                method: methodName,
                vendor_frame: frame.getFileName().includes('node_modules'),
            },
        };
    };
    return CallerPayload;
}(Payload));

var ColorPayload = (function (_super) {
    __extends(ColorPayload, _super);
    function ColorPayload(color) {
        var _this = _super.call(this) || this;
        _this.color = color;
        return _this;
    }
    ColorPayload.prototype.getType = function () {
        return 'color';
    };
    ColorPayload.prototype.getContent = function () {
        return {
            color: this.color,
        };
    };
    return ColorPayload;
}(Payload));

var ConfettiPayload = (function (_super) {
    __extends(ConfettiPayload, _super);
    function ConfettiPayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfettiPayload.prototype.getType = function () {
        return 'confetti';
    };
    return ConfettiPayload;
}(Payload));

var consoleLog = console.log.bind({});
var consoleWrapper = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof Ray.client !== 'undefined' && Ray.client.isRayAvailable()) {
        (_a = Ray.create()).send.apply(_a, args);
    }
    consoleLog.apply(void 0, args);
};
var ConsoleInterceptor = (function () {
    function ConsoleInterceptor() {
    }
    ConsoleInterceptor.prototype.enable = function () {
        ConsoleInterceptor.active = true;
        console.log = consoleWrapper;
    };
    ConsoleInterceptor.prototype.disable = function () {
        ConsoleInterceptor.active = false;
        console.log = consoleLog;
    };
    ConsoleInterceptor.prototype.active = function () {
        return ConsoleInterceptor.active;
    };
    ConsoleInterceptor.active = false;
    return ConsoleInterceptor;
}());

var Counters = (function () {
    function Counters() {
        this.counters = {};
    }
    Counters.prototype.increment = function (name) {
        if (typeof this.counters[name] === 'undefined') {
            this.counters[name] = [ray(), 0];
        }
        var data = this.counters[name];
        var ray$1 = data[0];
        var times = data[1];
        var newTimes = times + 1;
        this.counters[name] = [ray$1, newTimes];
        return [ray$1, newTimes];
    };
    Counters.prototype.get = function (name) {
        if (typeof this.counters[name] === 'undefined') {
            return 0;
        }
        return this.counters[name][1];
    };
    Counters.prototype.clear = function () {
        this.counters = [];
    };
    Counters.prototype.setRay = function (name, ray) {
        this.counters[name][0] = ray;
    };
    Counters.prototype.getCounters = function () {
        return this.counters;
    };
    return Counters;
}());

var CreateLockPayload = (function (_super) {
    __extends(CreateLockPayload, _super);
    function CreateLockPayload(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        return _this;
    }
    CreateLockPayload.prototype.getType = function () {
        return 'create_lock';
    };
    CreateLockPayload.prototype.getContent = function () {
        return {
            name: this.name,
        };
    };
    return CreateLockPayload;
}(Payload));

var CustomPayload = (function (_super) {
    __extends(CustomPayload, _super);
    function CustomPayload(content, label) {
        if (label === void 0) { label = ''; }
        var _this = _super.call(this) || this;
        _this.content = content;
        _this.label = label;
        return _this;
    }
    CustomPayload.prototype.getType = function () {
        return 'custom';
    };
    CustomPayload.prototype.getContent = function () {
        return {
            content: this.content,
            label: this.label,
        };
    };
    return CustomPayload;
}(Payload));

var DatePayload = (function (_super) {
    __extends(DatePayload, _super);
    function DatePayload(date, format) {
        if (format === void 0) { format = 'YYYY-MM-DD hh:mm:ss'; }
        var _this = _super.call(this) || this;
        _this.date = date;
        _this.format = format;
        return _this;
    }
    DatePayload.prototype.getType = function () {
        return 'carbon';
    };
    DatePayload.prototype.getContent = function () {
        return {
            formatted: this.date ? this.getFormatted() : null,
            timestamp: this.date ? this.getTimestamp() : null,
            timezone: this.date ? this.getTimezoneName() : null,
        };
    };
    DatePayload.prototype.getTimestamp = function () {
        var _a;
        return dayjs((_a = this.date) === null || _a === void 0 ? void 0 : _a.toISOString()).unix();
    };
    DatePayload.prototype.getFormatted = function () {
        var _a;
        return dayjs((_a = this.date) === null || _a === void 0 ? void 0 : _a.toISOString()).format(this.format);
    };
    DatePayload.prototype.getTimezoneName = function () {
        if (this.date === null) {
            return '--';
        }
        var dateObj = this.date ? this.date : new Date();
        var matches = /\((.*)\)/.exec(dateObj.toString());
        return matches ? matches[1] : '--';
    };
    return DatePayload;
}(Payload));

var DecodedJsonPayload = (function (_super) {
    __extends(DecodedJsonPayload, _super);
    function DecodedJsonPayload(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    DecodedJsonPayload.prototype.getType = function () {
        return 'custom';
    };
    DecodedJsonPayload.prototype.getContent = function () {
        var decodedJson = JSON.parse(this.value);
        return {
            content: decodedJson,
            label: 'JSON',
        };
    };
    return DecodedJsonPayload;
}(Payload));

var ErrorPayload = (function (_super) {
    __extends(ErrorPayload, _super);
    function ErrorPayload(err, label) {
        if (label === void 0) { label = 'Error'; }
        var _this = _super.call(this) || this;
        _this.err = err;
        _this.label = label;
        return _this;
    }
    ErrorPayload.prototype.getType = function () {
        return 'custom';
    };
    ErrorPayload.prototype.getContent = function () {
        return {
            content: this.formatError(),
            label: this.label,
        };
    };
    ErrorPayload.prototype.formatError = function () {
        return ("<span class=\"text-red-400 bold\">".concat(this.err.name, "</span>: <br>") +
            "<span class=\"pl-5 text-gray-500\">".concat(this.err.message, "</span>"));
    };
    return ErrorPayload;
}(Payload));

var ArgumentConverter = (function () {
    function ArgumentConverter() {
    }
    ArgumentConverter.convertToPrimitive = function (arg) {
        if (arg === null) {
            return { value: null, isHtml: false };
        }
        if (typeof arg === 'string') {
            return { value: arg, isHtml: false };
        }
        if (typeof arg === 'number') {
            return { value: arg, isHtml: false };
        }
        if (typeof arg === 'boolean') {
            return { value: arg, isHtml: false };
        }
        return { value: ArgumentConverter.prettyFormatForHtml(arg), isHtml: true };
    };
    ArgumentConverter.prettyFormatForHtml = function (arg) {
        var formatted = prettyFormat.format(arg, {
            indent: 4,
        })
            .replace(/ /g, '&nbsp;')
            .replace(/\r\n|\r|\n/g, '<br>')
            .replace(/("[^"]+")/g, '<code style="font-size: 0.8rem!important;" class="bold text-green-600 p-0">$1</code>')
            .replace(/Array(&nbsp;|\s)+(\[[^\]]+\])/g, '<code style="font-size: 0.8rem!important;" class="text-gray-500 p-0">Array$1$2</code>')
            .replace(/^(\[[^\]]+\])$/g, '<code style="font-size: 0.8rem!important;"class="text-gray-500 p-0">$1</code>')
            .replace(/(\{.+\})/g, '<code style="font-size: 0.8rem!important;" class="text-gray-600 ">$1</code>')
            .replace(/(Array|Object|Function|Circular|Symbol|WeakMap|Map)/g, '<span style="font-size: 0.8rem!important;" class="text-yellow-600 bold">$1</span>')
            .replace(/(true|false|null)/g, '<span style="font-size: 0.8rem!important;" class="text-indigo-600 bold">$1</span>')
            .replace(/(:&nbsp;|[,[\]{}])/g, '<span style="font-size: 0.8rem!important;" class="text-orange-400 bold">$1</span>');
        return "<code style=\"font-size: 0.8rem!important;\">".concat(formatted, "</code>");
    };
    return ArgumentConverter;
}());

var EventPayload = (function (_super) {
    __extends(EventPayload, _super);
    function EventPayload(eventName, payload) {
        var _this = _super.call(this) || this;
        _this.eventName = eventName;
        _this.payload = payload;
        return _this;
    }
    EventPayload.prototype.getType = function () {
        return 'event';
    };
    EventPayload.prototype.getContent = function () {
        return {
            name: this.eventName,
            event: this.payload[0],
            payload: ArgumentConverter.convertToPrimitive(this.payload).value,
            class_based_event: true,
        };
    };
    return EventPayload;
}(Payload));

var ExceptionPayload = (function (_super) {
    __extends(ExceptionPayload, _super);
    function ExceptionPayload(exception, meta) {
        if (meta === void 0) { meta = {}; }
        var _this = _super.call(this) || this;
        _this.meta = {};
        _this.stack = StackTrace.getSync();
        _this.exception = exception;
        _this.meta = meta;
        return _this;
    }
    ExceptionPayload.prototype.getType = function () {
        return 'exception';
    };
    ExceptionPayload.prototype.getContent = function () {
        return {
            class: this.exception.name,
            message: this.exception.message,
            frames: this.getFrames(),
            meta: this.meta,
        };
    };
    ExceptionPayload.prototype.getFrames = function () {
        var _this = this;
        return this.stack
            .slice(1)
            .map(function (frame) {
            var _a, _b;
            var funcNameParts = (_b = (_a = frame.functionName) === null || _a === void 0 ? void 0 : _a.split('.')) !== null && _b !== void 0 ? _b : ['unknown', 'unknown'];
            var methodName = funcNameParts.pop();
            var className = funcNameParts.pop();
            if (typeof className === 'undefined') {
                className = 'unknown';
            }
            return {
                file_name: _this.replaceRemotePathWithLocalPath(frame.getFileName()),
                line_number: frame.getLineNumber(),
                class: className,
                method: methodName,
                vendor_frame: frame.getFileName().includes('node_modules'),
                snippet: [],
            };
        })
            .filter(function (obj) { return !obj.file_name.startsWith('node:'); })
            .filter(function (obj) { return !obj.file_name.includes('jest-circus'); })
            .filter(function (obj) { return obj.class !== 'Ray' && obj.method !== 'exception'; });
    };
    return ExceptionPayload;
}(Payload));

var HideAppPayload = (function (_super) {
    __extends(HideAppPayload, _super);
    function HideAppPayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HideAppPayload.prototype.getType = function () {
        return 'hide_app';
    };
    return HideAppPayload;
}(Payload));

var HidePayload = (function (_super) {
    __extends(HidePayload, _super);
    function HidePayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HidePayload.prototype.getType = function () {
        return 'hide';
    };
    return HidePayload;
}(Payload));

var Hostname = (function () {
    function Hostname() {
    }
    Hostname.get = function () {
        var _a;
        return (_a = Hostname.hostname) !== null && _a !== void 0 ? _a : 'remote';
    };
    Hostname.set = function (hostname) {
        Hostname.hostname = hostname;
    };
    Hostname.hostname = null;
    return Hostname;
}());

var HtmlPayload = (function (_super) {
    __extends(HtmlPayload, _super);
    function HtmlPayload(html) {
        if (html === void 0) { html = ''; }
        var _this = _super.call(this) || this;
        _this.html = html;
        return _this;
    }
    HtmlPayload.prototype.getType = function () {
        return 'custom';
    };
    HtmlPayload.prototype.getContent = function () {
        return {
            content: this.html,
            label: 'HTML',
        };
    };
    return HtmlPayload;
}(Payload));

var ImagePayload = (function (_super) {
    __extends(ImagePayload, _super);
    function ImagePayload(location) {
        var _this = _super.call(this) || this;
        _this.location = location;
        return _this;
    }
    ImagePayload.prototype.getType = function () {
        return 'custom';
    };
    ImagePayload.prototype.getContent = function () {
        var location = this.location.replace('"', '\\\\"');
        return {
            content: "<img src=\"".concat(location, "\" alt=\"\" />"),
            label: 'Image',
        };
    };
    return ImagePayload;
}(Payload));

var JsonStringPayload = (function (_super) {
    __extends(JsonStringPayload, _super);
    function JsonStringPayload(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    JsonStringPayload.prototype.getType = function () {
        return 'json_string';
    };
    JsonStringPayload.prototype.getContent = function () {
        return {
            value: JSON.stringify(this.value),
        };
    };
    return JsonStringPayload;
}(Payload));

var LogPayload = (function (_super) {
    __extends(LogPayload, _super);
    function LogPayload(values) {
        var _this = _super.call(this) || this;
        if (!Array.isArray(values)) {
            values = [values];
        }
        _this.values = values;
        return _this;
    }
    LogPayload.createForArguments = function (args) {
        var dumpedArguments = args.map(function (argument) {
            return ArgumentConverter.convertToPrimitive(argument).value;
        });
        return new this(dumpedArguments);
    };
    LogPayload.prototype.getType = function () {
        return 'log';
    };
    LogPayload.prototype.getContent = function () {
        return {
            values: this.values,
        };
    };
    return LogPayload;
}(Payload));

function randomInteger(minimum, maximum) {
    if (maximum === undefined) {
        maximum = minimum;
        minimum = 0;
    }
    if (typeof minimum !== 'number' || typeof maximum !== 'number') {
        throw new TypeError('Expected all arguments to be numbers');
    }
    return Math.floor(Math.random() * (maximum - minimum + 1) + minimum);
}
var sleep = function (seconds) {
    return usleep(seconds * 1000);
};
var usleep = function (milliseconds) {
    var start = new Date().getTime();
    while (new Date().getTime() < start + milliseconds) { }
};
var encodeHtmlEntities = function (str) {
    var escapeChars = {
        '¢': 'cent',
        '£': 'pound',
        '¥': 'yen',
        '€': 'euro',
        '©': 'copy',
        '®': 'reg',
        '<': 'lt',
        '>': 'gt',
        '"': 'quot',
        '&': 'amp',
        "'": '#39',
    };
    var chars = Object.keys(escapeChars);
    var regex = new RegExp("[".concat(chars.join(''), "]"), 'g');
    return str.replace(regex, function (m) { return "&".concat(escapeChars[m], ";"); });
};
var spacesToHtmlSpaces = function (spaces) {
    return '&nbsp;'.repeat(spaces.length);
};
var encodeNewLinesToHtml = function (str) {
    return str.replace(/(\r\n|\r|\n)/g, '<br>');
};
var formatHtmlForDisplay = function (html, options) {
    if (options === void 0) { options = { encodeEntities: true }; }
    if (options.encodeEntities) {
        html = encodeHtmlEntities(html);
    }
    return encodeNewLinesToHtml(html.replace(/^(\s+)/gm, function (m) { return "".concat(spacesToHtmlSpaces(m)); }));
};
var nonCryptoUuidV4 = function () {
    var v4options = {
        random: [
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
            randomInteger(1, 255),
        ],
    };
    return uuid.v4(v4options).toString();
};
var end = function (arr) { return (arr.length ? arr[arr.length - 1] : false); };

var MeasurePayload = (function (_super) {
    __extends(MeasurePayload, _super);
    function MeasurePayload(name, stopwatchEvent) {
        var _this = _super.call(this) || this;
        _this.isNewTimer = false;
        _this.totalTime = 0;
        _this.maxMemoryUsageDuringTotalTime = 0;
        _this.timeSinceLastCall = 0;
        _this.maxMemoryUsageSinceLastCall = 0;
        _this.name = name;
        _this.totalTime = stopwatchEvent.getDuration();
        _this.maxMemoryUsageDuringTotalTime = stopwatchEvent.getMemory();
        var periods = stopwatchEvent.getPeriods();
        if (periods.length > 1) {
            _this.timeSinceLastCall = end(periods);
            _this.maxMemoryUsageSinceLastCall = 0;
        }
        return _this;
    }
    MeasurePayload.prototype.getType = function () {
        return 'measure';
    };
    MeasurePayload.prototype.concernsNewTimer = function () {
        this.isNewTimer = true;
        this.totalTime = 0;
        this.maxMemoryUsageDuringTotalTime = 0;
        this.timeSinceLastCall = 0;
        this.maxMemoryUsageSinceLastCall = 0;
        return this;
    };
    MeasurePayload.prototype.getContent = function () {
        return {
            name: this.name,
            is_new_timer: this.isNewTimer,
            total_time: this.totalTime,
            max_memory_usage_during_total_time: this.maxMemoryUsageDuringTotalTime,
            time_since_last_call: this.timeSinceLastCall,
            max_memory_usage_since_last_call: this.maxMemoryUsageSinceLastCall,
        };
    };
    return MeasurePayload;
}(Payload));

/**
 * Utility function that works like `Object.apply`, but copies getters and setters properly as well.  Additionally gives
 * the option to exclude properties by name.
 */
const copyProps = (dest, src, exclude = []) => {
    const props = Object.getOwnPropertyDescriptors(src);
    for (let prop of exclude)
        delete props[prop];
    Object.defineProperties(dest, props);
};
/**
 * Returns the full chain of prototypes up until Object.prototype given a starting object.  The order of prototypes will
 * be closest to farthest in the chain.
 */
const protoChain = (obj, currentChain = [obj]) => {
    const proto = Object.getPrototypeOf(obj);
    if (proto === null)
        return currentChain;
    return protoChain(proto, [...currentChain, proto]);
};
/**
 * Identifies the nearest ancestor common to all the given objects in their prototype chains.  For most unrelated
 * objects, this function should return Object.prototype.
 */
const nearestCommonProto = (...objs) => {
    if (objs.length === 0)
        return undefined;
    let commonProto = undefined;
    const protoChains = objs.map(obj => protoChain(obj));
    while (protoChains.every(protoChain => protoChain.length > 0)) {
        const protos = protoChains.map(protoChain => protoChain.pop());
        const potentialCommonProto = protos[0];
        if (protos.every(proto => proto === potentialCommonProto))
            commonProto = potentialCommonProto;
        else
            break;
    }
    return commonProto;
};
/**
 * Creates a new prototype object that is a mixture of the given prototypes.  The mixing is achieved by first
 * identifying the nearest common ancestor and using it as the prototype for a new object.  Then all properties/methods
 * downstream of this prototype (ONLY downstream) are copied into the new object.
 *
 * The resulting prototype is more performant than softMixProtos(...), as well as ES5 compatible.  However, it's not as
 * flexible as updates to the source prototypes aren't captured by the mixed result.  See softMixProtos for why you may
 * want to use that instead.
 */
const hardMixProtos = (ingredients, constructor, exclude = []) => {
    var _a;
    const base = (_a = nearestCommonProto(...ingredients)) !== null && _a !== void 0 ? _a : Object.prototype;
    const mixedProto = Object.create(base);
    // Keeps track of prototypes we've already visited to avoid copying the same properties multiple times.  We init the
    // list with the proto chain below the nearest common ancestor because we don't want any of those methods mixed in
    // when they will already be accessible via prototype access.
    const visitedProtos = protoChain(base);
    for (let prototype of ingredients) {
        let protos = protoChain(prototype);
        // Apply the prototype chain in reverse order so that old methods don't override newer ones.
        for (let i = protos.length - 1; i >= 0; i--) {
            let newProto = protos[i];
            if (visitedProtos.indexOf(newProto) === -1) {
                copyProps(mixedProto, newProto, ['constructor', ...exclude]);
                visitedProtos.push(newProto);
            }
        }
    }
    mixedProto.constructor = constructor;
    return mixedProto;
};
const unique = (arr) => arr.filter((e, i) => arr.indexOf(e) == i);

// Keeps track of constituent classes for every mixin class created by ts-mixer.
const mixins = new Map();
const getMixinsForClass = (clazz) => mixins.get(clazz);
const registerMixins = (mixedClass, constituents) => mixins.set(mixedClass, constituents);

const mergeObjectsOfDecorators = (o1, o2) => {
    var _a, _b;
    const allKeys = unique([...Object.getOwnPropertyNames(o1), ...Object.getOwnPropertyNames(o2)]);
    const mergedObject = {};
    for (let key of allKeys)
        mergedObject[key] = unique([...((_a = o1 === null || o1 === void 0 ? void 0 : o1[key]) !== null && _a !== void 0 ? _a : []), ...((_b = o2 === null || o2 === void 0 ? void 0 : o2[key]) !== null && _b !== void 0 ? _b : [])]);
    return mergedObject;
};
const mergePropertyAndMethodDecorators = (d1, d2) => {
    var _a, _b, _c, _d;
    return ({
        property: mergeObjectsOfDecorators((_a = d1 === null || d1 === void 0 ? void 0 : d1.property) !== null && _a !== void 0 ? _a : {}, (_b = d2 === null || d2 === void 0 ? void 0 : d2.property) !== null && _b !== void 0 ? _b : {}),
        method: mergeObjectsOfDecorators((_c = d1 === null || d1 === void 0 ? void 0 : d1.method) !== null && _c !== void 0 ? _c : {}, (_d = d2 === null || d2 === void 0 ? void 0 : d2.method) !== null && _d !== void 0 ? _d : {}),
    });
};
const mergeDecorators = (d1, d2) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        class: unique([...(_a = d1 === null || d1 === void 0 ? void 0 : d1.class) !== null && _a !== void 0 ? _a : [], ...(_b = d2 === null || d2 === void 0 ? void 0 : d2.class) !== null && _b !== void 0 ? _b : []]),
        static: mergePropertyAndMethodDecorators((_c = d1 === null || d1 === void 0 ? void 0 : d1.static) !== null && _c !== void 0 ? _c : {}, (_d = d2 === null || d2 === void 0 ? void 0 : d2.static) !== null && _d !== void 0 ? _d : {}),
        instance: mergePropertyAndMethodDecorators((_e = d1 === null || d1 === void 0 ? void 0 : d1.instance) !== null && _e !== void 0 ? _e : {}, (_f = d2 === null || d2 === void 0 ? void 0 : d2.instance) !== null && _f !== void 0 ? _f : {}),
    });
};
const decorators = new Map();
const findAllConstituentClasses = (...classes) => {
    var _a;
    const allClasses = new Set();
    const frontier = new Set([...classes]);
    while (frontier.size > 0) {
        for (let clazz of frontier) {
            const protoChainClasses = protoChain(clazz.prototype).map(proto => proto.constructor);
            const mixinClasses = (_a = getMixinsForClass(clazz)) !== null && _a !== void 0 ? _a : [];
            const potentiallyNewClasses = [...protoChainClasses, ...mixinClasses];
            const newClasses = potentiallyNewClasses.filter(c => !allClasses.has(c));
            for (let newClass of newClasses)
                frontier.add(newClass);
            allClasses.add(clazz);
            frontier.delete(clazz);
        }
    }
    return [...allClasses];
};
const deepDecoratorSearch = (...classes) => {
    const decoratorsForClassChain = findAllConstituentClasses(...classes)
        .map(clazz => decorators.get(clazz))
        .filter(decorators => !!decorators);
    if (decoratorsForClassChain.length == 0)
        return {};
    if (decoratorsForClassChain.length == 1)
        return decoratorsForClassChain[0];
    return decoratorsForClassChain.reduce((d1, d2) => mergeDecorators(d1, d2));
};

function Mixin(...constructors) {
    var _a, _b, _c;
    const prototypes = constructors.map(constructor => constructor.prototype);
    function MixedClass(...args) {
        for (const constructor of constructors)
            // @ts-ignore: potentially abstract class
            copyProps(this, new constructor(...args));
    }
    MixedClass.prototype = hardMixProtos(prototypes, MixedClass)
        ;
    Object.setPrototypeOf(MixedClass, hardMixProtos(constructors, null, ['prototype'])
        );
    let DecoratedMixedClass = MixedClass;
    {
        const classDecorators = deepDecoratorSearch(...constructors)
            ;
        for (let decorator of (_a = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.class) !== null && _a !== void 0 ? _a : []) {
            const result = decorator(DecoratedMixedClass);
            if (result) {
                DecoratedMixedClass = result;
            }
        }
        applyPropAndMethodDecorators((_b = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.static) !== null && _b !== void 0 ? _b : {}, DecoratedMixedClass);
        applyPropAndMethodDecorators((_c = classDecorators === null || classDecorators === void 0 ? void 0 : classDecorators.instance) !== null && _c !== void 0 ? _c : {}, DecoratedMixedClass.prototype);
    }
    registerMixins(DecoratedMixedClass, constructors);
    return DecoratedMixedClass;
}
const applyPropAndMethodDecorators = (propAndMethodDecorators, target) => {
    const propDecorators = propAndMethodDecorators.property;
    const methodDecorators = propAndMethodDecorators.method;
    if (propDecorators)
        for (let key in propDecorators)
            for (let decorator of propDecorators[key])
                decorator(target, key);
    if (methodDecorators)
        for (let key in methodDecorators)
            for (let decorator of methodDecorators[key])
                decorator(target, key, Object.getOwnPropertyDescriptor(target, key));
};

var NewScreenPayload = (function (_super) {
    __extends(NewScreenPayload, _super);
    function NewScreenPayload(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        return _this;
    }
    NewScreenPayload.prototype.getType = function () {
        return 'new_screen';
    };
    NewScreenPayload.prototype.getContent = function () {
        return {
            name: this.name,
        };
    };
    return NewScreenPayload;
}(Payload));

var NotifyPayload = (function (_super) {
    __extends(NotifyPayload, _super);
    function NotifyPayload(text) {
        var _this = _super.call(this) || this;
        _this.text = text;
        return _this;
    }
    NotifyPayload.prototype.getType = function () {
        return 'notify';
    };
    NotifyPayload.prototype.getContent = function () {
        return {
            value: this.text,
        };
    };
    return NotifyPayload;
}(Payload));

var BoolPayload = (function (_super) {
    __extends(BoolPayload, _super);
    function BoolPayload(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    BoolPayload.prototype.getType = function () {
        return 'custom';
    };
    BoolPayload.prototype.getContent = function () {
        return {
            content: this.value,
            label: 'Boolean',
        };
    };
    return BoolPayload;
}(Payload));

var NullPayload = (function (_super) {
    __extends(NullPayload, _super);
    function NullPayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NullPayload.prototype.getType = function () {
        return 'custom';
    };
    NullPayload.prototype.getContent = function () {
        return {
            content: null,
            label: 'Null',
        };
    };
    return NullPayload;
}(Payload));

var PayloadFactory = (function () {
    function PayloadFactory(values) {
        this.values = values;
    }
    PayloadFactory.createForValues = function (args) {
        return new this(args).getPayloads();
    };
    PayloadFactory.registerPayloadFinder = function (callable) {
        this.payloadFinder = callable;
    };
    PayloadFactory.prototype.getPayloads = function () {
        var _this = this;
        return this.values.map(function (value) {
            return _this.getPayload(value);
        });
    };
    PayloadFactory.prototype.getPayload = function (value) {
        if (typeof value === 'boolean') {
            return new BoolPayload(value);
        }
        if (value === null) {
            return new NullPayload();
        }
        var convertedResult = ArgumentConverter.convertToPrimitive(value);
        if (convertedResult.isHtml) {
            return new HtmlPayload(convertedResult.value);
        }
        return new LogPayload(convertedResult.value);
    };
    PayloadFactory.payloadFinder = null;
    return PayloadFactory;
}());

var RayColors = (function () {
    function RayColors() {
    }
    RayColors.prototype.color = function (name) {
        return this;
    };
    RayColors.prototype.green = function () {
        return this.color('green');
    };
    RayColors.prototype.orange = function () {
        return this.color('orange');
    };
    RayColors.prototype.red = function () {
        return this.color('red');
    };
    RayColors.prototype.purple = function () {
        return this.color('purple');
    };
    RayColors.prototype.blue = function () {
        return this.color('blue');
    };
    RayColors.prototype.gray = function () {
        return this.color('gray');
    };
    return RayColors;
}());

var Settings = (function () {
    function Settings(settings) {
        this.enable = true;
        this._host = 'localhost';
        this._port = 23517;
        this._scheme = 'http';
        this.remote_path = null;
        this.local_path = null;
        this.always_send_raw_values = false;
        this.intercept_console_log = false;
        this.enabled_callback = null;
        this.sent_payload_callback = null;
        this.sending_payload_callback = null;
        this.originalSettings = Object.assign({}, settings);
        for (var prop in settings) {
            this[prop] = settings[prop];
        }
    }
    Object.defineProperty(Settings.prototype, "host", {
        get: function () {
            return this._host;
        },
        set: function (value) {
            this._host = value;
            Ray.useClient(new Client(this.port, this.host, this.scheme));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Settings.prototype, "port", {
        get: function () {
            return this._port;
        },
        set: function (value) {
            this._port = value;
            Ray.useClient(new Client(this.port, this.host, this.scheme));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Settings.prototype, "scheme", {
        get: function () {
            return this._scheme;
        },
        set: function (value) {
            this._scheme = value;
            Ray.useClient(new Client(this.port, this.host, this.scheme));
        },
        enumerable: false,
        configurable: true
    });
    Settings.prototype.toObject = function () {
        return this.originalSettings;
    };
    return Settings;
}());

var RaySizes = (function () {
    function RaySizes() {
    }
    RaySizes.prototype.size = function (size) {
        return this;
    };
    RaySizes.prototype.small = function () {
        return this.size('sm');
    };
    RaySizes.prototype.large = function () {
        return this.size('lg');
    };
    return RaySizes;
}());

var RemovePayload = (function (_super) {
    __extends(RemovePayload, _super);
    function RemovePayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RemovePayload.prototype.getType = function () {
        return 'remove';
    };
    return RemovePayload;
}(Payload));

var Request = (function () {
    function Request(uuid, payloads, meta) {
        if (meta === void 0) { meta = []; }
        this.uuid = uuid;
        this.payloads = payloads;
        this.meta = meta;
    }
    Request.prototype.toArray = function () {
        return {
            uuid: this.uuid,
            payloads: this.payloads.map(function (payload) { return payload.toArray(); }),
            meta: this.meta,
        };
    };
    Request.prototype.toJson = function () {
        return JSON.stringify(this.toArray());
    };
    return Request;
}());

var ShowAppPayload = (function (_super) {
    __extends(ShowAppPayload, _super);
    function ShowAppPayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShowAppPayload.prototype.getType = function () {
        return 'show_app';
    };
    return ShowAppPayload;
}(Payload));

var SizePayload = (function (_super) {
    __extends(SizePayload, _super);
    function SizePayload(size) {
        var _this = _super.call(this) || this;
        _this.size = size;
        return _this;
    }
    SizePayload.prototype.getType = function () {
        return 'size';
    };
    SizePayload.prototype.getContent = function () {
        return {
            size: this.size,
        };
    };
    return SizePayload;
}(Payload));

var StopwatchEvent = (function () {
    function StopwatchEvent(sw, lapTime) {
        if (lapTime === void 0) { lapTime = null; }
        var _a;
        this.laps = [];
        this.name = (_a = sw.name) === null || _a === void 0 ? void 0 : _a.slice(0);
        this.laps = sw.laps.slice(0);
        this.startedAt = sw.startedAt;
        this.endedAt = sw.endedAt;
        this.lapTime = lapTime !== null && lapTime !== void 0 ? lapTime : new Date().getTime();
    }
    StopwatchEvent.prototype.getDuration = function () {
        return this.laps.reduce(function (prev, cur) { return cur + prev; }, 0);
    };
    StopwatchEvent.prototype.getMemory = function () {
        return 0;
    };
    StopwatchEvent.prototype.getPeriods = function () {
        return this.laps.slice();
    };
    StopwatchEvent.prototype.getPreviousDuration = function () {
        return end(this.laps) - (new Date().getTime() - this.lapTime);
    };
    return StopwatchEvent;
}());

var Stopwatch = (function () {
    function Stopwatch(name) {
        if (name === void 0) { name = undefined; }
        this.laps = [];
        this.startedAt = 0;
        this.endedAt = 0;
        this.name = name;
        this.sw = new stopwatchNode.StopWatch(name);
        this.laps = [];
        this.startedAt = 0;
        this.endedAt = 0;
    }
    Stopwatch.prototype.initialize = function (name) {
        this.name = name;
        this.sw = new stopwatchNode.StopWatch(name);
        this.laps = [];
        this.startedAt = 0;
        this.endedAt = 0;
    };
    Stopwatch.prototype.start = function (name) {
        this.startedAt = new Date().getTime();
        this.sw.start(name);
        return new StopwatchEvent(this);
    };
    Stopwatch.prototype.lap = function () {
        var lapTime = new Date().getTime();
        var duration = lapTime - this.startedAt;
        this.laps.push(duration - this.totalDuration());
        return new StopwatchEvent(this, lapTime);
    };
    Stopwatch.prototype.stop = function () {
        this.sw.stop();
        this.endedAt = new Date().getTime();
        var duration = this.endedAt - this.startedAt;
        this.laps.push(duration - this.totalDuration());
        return new StopwatchEvent(this);
    };
    Stopwatch.prototype.totalDuration = function () {
        return this.laps.reduce(function (prev, cur) {
            return cur + prev;
        }, 0);
    };
    Stopwatch.prototype.reset = function () {
        this.initialize(this.name);
        return this;
    };
    Stopwatch.prototype.getLaps = function () {
        return this.laps;
    };
    return Stopwatch;
}());

var TablePayload = (function (_super) {
    __extends(TablePayload, _super);
    function TablePayload(values, label) {
        if (label === void 0) { label = 'Table'; }
        var _this = _super.call(this) || this;
        _this.values = values;
        _this.label = label;
        return _this;
    }
    TablePayload.prototype.getType = function () {
        return 'table';
    };
    TablePayload.prototype.getContent = function () {
        var values = this.getValues();
        return {
            values: values,
            label: this.label,
        };
    };
    TablePayload.prototype.getValues = function () {
        if (Array.isArray(this.values)) {
            return this.values.map(function (item) {
                return ArgumentConverter.convertToPrimitive(item).value;
            });
        }
        var values = {};
        for (var prop in this.values) {
            values[prop] = ArgumentConverter.convertToPrimitive(this.values[prop]).value;
        }
        return values;
    };
    return TablePayload;
}(Payload));

var TracePayload = (function (_super) {
    __extends(TracePayload, _super);
    function TracePayload(frames) {
        var _this = _super.call(this) || this;
        _this.startFromIndexNum = null;
        _this.limitNum = null;
        _this.frames = RemovesRayFrames.removeRayFrames(frames);
        return _this;
    }
    TracePayload.prototype.startFromIndex = function (index) {
        this.startFromIndexNum = index;
        return this;
    };
    TracePayload.prototype.limit = function (limit) {
        this.limitNum = limit;
        return this;
    };
    TracePayload.prototype.getType = function () {
        return 'trace';
    };
    TracePayload.prototype.getContent = function () {
        var _this = this;
        var _a;
        var frames = this.frames.map(function (frame) {
            var funcNameParts = frame.getFunctionName().replace('Proxy.', '').split('.').slice(0);
            var className = funcNameParts.length ? funcNameParts.shift() : '';
            var methodName = funcNameParts.join('.');
            return {
                file_name: _this.replaceRemotePathWithLocalPath(frame.getFileName()),
                line_number: frame.getLineNumber(),
                class: className,
                method: methodName,
                vendor_frame: frame.getFileName().includes('node_modules'),
            };
        });
        if (this.limitNum !== null) {
            frames = frames.slice((_a = this.startFromIndexNum) !== null && _a !== void 0 ? _a : 0, this.limitNum);
        }
        return { frames: frames };
    };
    return TracePayload;
}(Payload));

var XmlPayload = (function (_super) {
    __extends(XmlPayload, _super);
    function XmlPayload(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    XmlPayload.prototype.getType = function () {
        return 'custom';
    };
    XmlPayload.prototype.getContent = function () {
        var content = this.formatXmlForDisplay(this.value);
        return {
            content: content,
            label: 'XML',
        };
    };
    XmlPayload.prototype.formatXmlForDisplay = function (xml) {
        var content = this.formatAndIndentXml(xml);
        return this.encodeXml(content);
    };
    XmlPayload.prototype.encodeXml = function (xml) {
        return formatHtmlForDisplay(xml, { encodeEntities: true });
    };
    XmlPayload.prototype.formatAndIndentXml = function (xml) {
        return formatXml(xml.toString(), {
            indentation: '    ',
            collapseContent: true,
            lineSeparator: '\n',
        });
    };
    return XmlPayload;
}(Payload));

var HtmlMarkupPayload = (function (_super) {
    __extends(HtmlMarkupPayload, _super);
    function HtmlMarkupPayload(value, options) {
        if (options === void 0) { options = { highlight: 'none' }; }
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.options = options;
        return _this;
    }
    HtmlMarkupPayload.prototype.getType = function () {
        return 'custom';
    };
    HtmlMarkupPayload.prototype.getContent = function () {
        var content = this.formatMarkupForDisplay(this.value);
        return {
            content: content,
            label: 'Markup',
        };
    };
    HtmlMarkupPayload.prototype.formatMarkupForDisplay = function (markup) {
        var content = this.formatAndIndentMarkup(markup);
        return this.highlightHtmlMarkup(formatHtmlForDisplay(content, { encodeEntities: true }));
    };
    HtmlMarkupPayload.prototype.formatAndIndentMarkup = function (markup) {
        return formatXml(markup.toString(), {
            indentation: '    ',
            collapseContent: true,
            lineSeparator: '\n',
        });
    };
    HtmlMarkupPayload.prototype.highlightHtmlMarkup = function (markup) {
        return markup
            .replace(/&quot;/g, '"')
            .replace(/="([^"]+)"/g, "=<span style='color:#16A34A;'>&quot;$1&quot;</span>")
            .replace(/(&lt;[A-Za-z\d-]+)(\s|&nbsp;|&gt;)/g, '<span style="color:#1D4ED8;">$1</span>$2')
            .replace(/(&lt;\/[A-Za-z\d-]+)(&gt;)/g, '<span style="color:#1D4ED8;">$1$2</span>');
    };
    return HtmlMarkupPayload;
}(Payload));

var TextPayload = (function (_super) {
    __extends(TextPayload, _super);
    function TextPayload(text) {
        var _this = _super.call(this) || this;
        _this.text = text;
        return _this;
    }
    TextPayload.prototype.getType = function () {
        return 'custom';
    };
    TextPayload.prototype.getContent = function () {
        return {
            content: this.formatContent(),
            label: 'Text',
        };
    };
    TextPayload.prototype.formatContent = function () {
        return formatHtmlForDisplay(this.text, { encodeEntities: true });
    };
    return TextPayload;
}(Payload));

var CacheStore = (function () {
    function CacheStore(clock) {
        this.store = [];
        this.clock = clock;
    }
    CacheStore.prototype.hit = function () {
        this.store.push(this.clock.now());
        return this;
    };
    CacheStore.prototype.clear = function () {
        this.store = [];
        return this;
    };
    CacheStore.prototype.count = function () {
        return this.store.length;
    };
    CacheStore.prototype.countLastSecond = function () {
        var _this = this;
        var lastSecond = this.clock.now().modify('-1 second');
        var amount = 0;
        this.store.forEach(function (item) {
            if (_this.isBetween(item, lastSecond, _this.clock.now())) {
                amount++;
            }
        });
        return amount;
    };
    CacheStore.prototype.isBetween = function (toCheck, start, end) {
        return toCheck.getTimestamp() >= start.getTimestamp() && toCheck.getTimestamp() <= end.getTimestamp();
    };
    return CacheStore;
}());

var Clock = (function () {
    function Clock() {
    }
    return Clock;
}());

var DateImmutable = (function () {
    function DateImmutable(date) {
        if (date === void 0) { date = null; }
        this.date = date !== null && date !== void 0 ? date : new Date();
        this.dateStr = this.date.toISOString();
        this.dateTs = this.date.getTime();
    }
    Object.defineProperty(DateImmutable.prototype, "date", {
        get: function () {
            return dayjs(this.dateStr).toDate();
        },
        set: function (value) {
            this.dateTs = value.getTime();
            this.dateStr = value.toISOString();
        },
        enumerable: false,
        configurable: true
    });
    DateImmutable.createFrom = function (date) {
        return new DateImmutable(date);
    };
    DateImmutable.prototype.getTimestamp = function () {
        return Math.floor(this.dateTs / 1000);
    };
    DateImmutable.prototype.modify = function (str) {
        var strParts = str.split(' ');
        var parts = [];
        for (var idx = 0; idx < strParts.length; idx++) {
            parts.push({
                value: Number(strParts[idx]),
                unit: strParts[idx + 1],
            });
            idx++;
        }
        var tempDate = dayjs(this.getTimestamp() * 1000);
        parts.forEach(function (part) {
            tempDate = tempDate.add(part.value * 1000);
        });
        return DateImmutable.createFrom(tempDate.toDate());
    };
    return DateImmutable;
}());

var SystemClock = (function (_super) {
    __extends(SystemClock, _super);
    function SystemClock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SystemClock.prototype.now = function () {
        return new DateImmutable();
    };
    return SystemClock;
}(Clock));

var RateLimiter = (function () {
    function RateLimiter(maxCalls, maxPerSecond) {
        if (maxCalls === void 0) { maxCalls = null; }
        if (maxPerSecond === void 0) { maxPerSecond = null; }
        this.notified = false;
        this.maxCalls = maxCalls;
        this.maxPerSecond = maxPerSecond;
        this.cache = new CacheStore(new SystemClock());
    }
    RateLimiter.disabled = function () {
        return new RateLimiter(null, null);
    };
    RateLimiter.prototype.hit = function () {
        this.cache.hit();
        return this;
    };
    RateLimiter.prototype.max = function (maxCalls) {
        if (maxCalls === void 0) { maxCalls = null; }
        this.maxCalls = maxCalls;
        return this;
    };
    RateLimiter.prototype.perSecond = function (callsPerSecond) {
        if (callsPerSecond === void 0) { callsPerSecond = null; }
        this.maxPerSecond = callsPerSecond;
        return this;
    };
    RateLimiter.prototype.isMaxReached = function () {
        if (this.maxCalls === null) {
            return false;
        }
        var reached = this.cache.count() >= this.maxCalls;
        if (!reached) {
            this.notified = false;
        }
        return reached;
    };
    RateLimiter.prototype.isMaxPerSecondReached = function () {
        if (this.maxPerSecond === null) {
            return false;
        }
        var reached = this.cache.countLastSecond() >= this.maxPerSecond;
        if (reached === false) {
            this.notified = false;
        }
        return reached;
    };
    RateLimiter.prototype.clear = function () {
        this.maxCalls = null;
        this.maxPerSecond = null;
        this.cache.clear();
        return this;
    };
    RateLimiter.prototype.isNotified = function () {
        return this.notified;
    };
    RateLimiter.prototype.notify = function () {
        this.notified = true;
    };
    RateLimiter.prototype.getCache = function () {
        return this.cache;
    };
    return RateLimiter;
}());

var Limiters = (function () {
    function Limiters() {
        this.counters = {};
    }
    Limiters.prototype.initialize = function (origin, limit) {
        var fingerprint = "".concat(origin.file, ":").concat(origin.line_number);
        if (typeof this.counters[fingerprint] === 'undefined') {
            this.counters[fingerprint] = { counter: 0, limit: limit, valid: true };
        }
        return this.counters[fingerprint];
    };
    Limiters.prototype.increment = function (origin) {
        var name = "".concat(origin.file, ":").concat(origin.line_number);
        if (typeof this.counters[name] === 'undefined') {
            return { counter: 0, limit: 0, valid: false };
        }
        var _a = this.counters[name], counter = _a.counter, limit = _a.limit, valid = _a.valid;
        this.counters[name] = { counter: counter + 1, limit: limit, valid: valid };
        return this.counters[name];
    };
    Limiters.prototype.canSendPayload = function (origin) {
        var name = "".concat(origin.file, ":").concat(origin.line_number);
        if (typeof this.counters[name] === 'undefined') {
            return true;
        }
        var _a = this.counters[name], counter = _a.counter, limit = _a.limit, valid = _a.valid;
        return valid && (counter < limit || limit <= 0);
    };
    return Limiters;
}());

var LabelPayload = (function (_super) {
    __extends(LabelPayload, _super);
    function LabelPayload(label) {
        var _this = _super.call(this) || this;
        _this.label = label;
        return _this;
    }
    LabelPayload.prototype.getType = function () {
        return 'label';
    };
    LabelPayload.prototype.getContent = function () {
        return {
            label: this.label,
        };
    };
    return LabelPayload;
}(Payload));

var SeparatorPayload = (function (_super) {
    __extends(SeparatorPayload, _super);
    function SeparatorPayload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SeparatorPayload.prototype.getType = function () {
        return 'separator';
    };
    return SeparatorPayload;
}(Payload));

var ScreenColorPayload = (function (_super) {
    __extends(ScreenColorPayload, _super);
    function ScreenColorPayload(color) {
        var _this = _super.call(this) || this;
        _this.color = color;
        return _this;
    }
    ScreenColorPayload.prototype.getType = function () {
        return 'screen_color';
    };
    ScreenColorPayload.prototype.getContent = function () {
        return {
            color: this.color,
        };
    };
    return ScreenColorPayload;
}(Payload));

var Ray = (function (_super) {
    __extends(Ray, _super);
    function Ray(settings, client, uuid, inCallback) {
        if (client === void 0) { client = null; }
        if (uuid === void 0) { uuid = null; }
        if (inCallback === void 0) { inCallback = false; }
        var _this = this;
        var _a, _b, _c;
        _this = _super.call(this) || this;
        _this.inCallback = false;
        _this.limitOrigin = null;
        _this.canSendPayload = true;
        if (Ray.defaultSettings.not_defined === true) {
            Ray.defaultSettings = {
                enable: true,
                host: 'localhost',
                port: 23517,
                scheme: 'http',
                local_path: null,
                remote_path: null,
                always_send_raw_values: false,
                enabled_callback: null,
                sending_payload_callback: null,
                sent_payload_callback: null,
                not_defined: false,
            };
        }
        _this.inCallback = inCallback;
        _this.settings = new Settings(Ray.defaultSettings);
        if (Ray.enabled === null) {
            Ray.enabled = _this.settings.enable !== false;
        }
        Ray.client = (_a = client !== null && client !== void 0 ? client : Ray.client) !== null && _a !== void 0 ? _a : new Client(_this.settings.port, _this.settings.host);
        Ray._rateLimiter = (_b = Ray._rateLimiter) !== null && _b !== void 0 ? _b : RateLimiter.disabled();
        _this.uuid = (_c = uuid !== null && uuid !== void 0 ? uuid : Ray.fakeUuid) !== null && _c !== void 0 ? _c : nonCryptoUuidV4();
        if (_this.settings.intercept_console_log && !_this.interceptor().active()) {
            _this.interceptor().enable();
        }
        _this.loadMacros();
        return _this;
    }
    Ray.create = function (client, uuid) {
        if (client === void 0) { client = null; }
        if (uuid === void 0) { uuid = null; }
        if (Ray.defaultSettings.not_defined === true) {
            Ray.defaultSettings = {
                enable: true,
                host: 'localhost',
                port: 23517,
                scheme: 'http',
                local_path: null,
                remote_path: null,
                always_send_raw_values: false,
                not_defined: false,
                intercept_console_log: false,
                enabled_callback: null,
                sending_payload_callback: null,
                sent_payload_callback: null,
            };
        }
        var settings = new Settings(Ray.defaultSettings);
        return new this(settings, client, uuid);
    };
    Ray.useDefaultSettings = function (settings) {
        if (Ray.defaultSettings.not_defined === true) {
            Ray.defaultSettings = {
                enable: true,
                host: 'localhost',
                port: 23517,
                scheme: 'http',
                local_path: null,
                remote_path: null,
                always_send_raw_values: false,
                enabled_callback: null,
                sending_payload_callback: null,
                sent_payload_callback: null,
                not_defined: false,
            };
        }
        Ray.defaultSettings = Object.assign({}, Ray.defaultSettings, settings);
        Ray.defaultSettings.not_defined = false;
        Ray.client = new Client(this.defaultSettings.port, this.defaultSettings.host);
        return this;
    };
    Ray.prototype.loadMacros = function () {
        for (var name_1 in Ray.macros) {
            var handler = Ray.macros[name_1];
            this[name_1] = handler.bind(this);
        }
        return this;
    };
    Ray.prototype.interceptor = function () {
        return Ray.interceptor;
    };
    Ray.prototype.client = function () {
        return Ray.client;
    };
    Ray.prototype.enable = function () {
        Ray.enabled = true;
        return this;
    };
    Ray.prototype.disable = function () {
        Ray.enabled = false;
        return this;
    };
    Ray.prototype.enabled = function () {
        if (typeof this.settings.enabled_callback === 'function') {
            return Ray.enabled && this.settings.enabled_callback();
        }
        return Ray.enabled;
    };
    Ray.prototype.disabled = function () {
        return !this.enabled();
    };
    Ray.useClient = function (client) {
        this.client = client;
    };
    Ray.prototype.project = function (projectName) {
        Ray.projectName = projectName;
        return this;
    };
    Ray.prototype.newScreen = function (name) {
        if (name === void 0) { name = ''; }
        var payload = new NewScreenPayload(name);
        return this.sendRequest(payload);
    };
    Ray.prototype.clearAll = function () {
        var payload = new ClearAllPayload();
        return this.sendRequest(payload);
    };
    Ray.prototype.clearScreen = function () {
        return this.newScreen();
    };
    Ray.prototype.color = function (color) {
        var payload = new ColorPayload(color);
        return this.sendRequest(payload);
    };
    Ray.prototype.confetti = function () {
        var payload = new ConfettiPayload();
        return this.sendRequest(payload);
    };
    Ray.prototype.screenColor = function (color) {
        var payload = new ScreenColorPayload(color);
        return this.sendRequest(payload);
    };
    Ray.prototype.label = function (label) {
        var payload = new LabelPayload(label);
        return this.sendRequest(payload);
    };
    Ray.prototype.size = function (size) {
        var payload = new SizePayload(size);
        return this.sendRequest(payload);
    };
    Ray.prototype.remove = function () {
        var payload = new RemovePayload();
        return this.sendRequest(payload);
    };
    Ray.prototype.hide = function () {
        var payload = new HidePayload();
        return this.sendRequest(payload);
    };
    Ray.prototype.notify = function (text) {
        var payload = new NotifyPayload(text);
        return this.sendRequest(payload);
    };
    Ray.prototype.toJson = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var payloads = values.map(function (value) { return new JsonStringPayload(value); });
        return this.sendRequest(payloads);
    };
    Ray.prototype.json = function () {
        var jsons = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            jsons[_i] = arguments[_i];
        }
        var payloads = jsons.map(function (json) { return new DecodedJsonPayload(json); });
        return this.sendRequest(payloads);
    };
    Ray.prototype.file = function (filename) {
        console.error("file() unsupport on web (".concat(filename, ")"));
        return this;
    };
    Ray.prototype.image = function (location) {
        var payload = new ImagePayload(location);
        return this.sendRequest(payload);
    };
    Ray.prototype.die = function (status) {
        if (status === void 0) { status = ''; }
        throw new Error("Ray.die() called: ".concat(status ? status : 'no message'));
    };
    Ray.prototype.className = function (object) {
        return this.send(object.constructor.name);
    };
    Ray.prototype.error = function (err) {
        var payload = new ErrorPayload(err, 'Error');
        this.sendRequest(payload);
        this.red();
        return this;
    };
    Ray.prototype.event = function (eventName, data) {
        if (data === void 0) { data = []; }
        var payload = new EventPayload(eventName, data);
        return this.sendRequest(payload);
    };
    Ray.prototype.exception = function (err, meta) {
        if (meta === void 0) { meta = {}; }
        var payload = new ExceptionPayload(err, meta);
        this.sendRequest(payload);
        this.red();
        return this;
    };
    Ray.prototype.showWhen = function (booleanOrCallable) {
        if (typeof booleanOrCallable === 'function') {
            booleanOrCallable = booleanOrCallable();
        }
        if (!booleanOrCallable) {
            this.remove();
        }
        return this;
    };
    Ray.prototype.showIf = function (booleanOrCallable) {
        return this.showWhen(booleanOrCallable);
    };
    Ray.prototype.removeWhen = function (booleanOrCallable) {
        if (typeof booleanOrCallable === 'function') {
            booleanOrCallable = booleanOrCallable();
        }
        if (booleanOrCallable) {
            this.remove();
        }
        return this;
    };
    Ray.prototype.removeIf = function (booleanOrCallable) {
        return this.removeWhen(booleanOrCallable);
    };
    Ray.prototype.ban = function () {
        return this.send('🕶');
    };
    Ray.prototype.charles = function () {
        return this.send('🎶 🎹 🎷 🕺');
    };
    Ray.prototype.table = function (values, label) {
        if (label === void 0) { label = 'Table'; }
        var payload = new TablePayload(values, label);
        return this.sendRequest(payload);
    };
    Ray.prototype.count = function (name) {
        var _a, _b, _c;
        if (name === void 0) { name = null; }
        var fingerprint = md5("".concat((_a = this.getCaller()) === null || _a === void 0 ? void 0 : _a.getFileName()).concat((_b = this.getCaller()) === null || _b === void 0 ? void 0 : _b.getLineNumber()));
        var _d = Ray.counters.increment((_c = name !== null && name !== void 0 ? name : fingerprint) !== null && _c !== void 0 ? _c : 'none'), ray = _d[0], times = _d[1];
        var message = "Called ";
        if (name) {
            message += "'".concat(name, "' ");
        }
        message += "".concat(times, " ").concat(times === 1 ? 'time' : 'times', ".");
        ray.sendCustom(message, 'Count');
        return ray;
    };
    Ray.prototype.clearCounters = function () {
        Ray.counters.clear();
        return this;
    };
    Ray.prototype.pause = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lockName, payload;
            var _this = this;
            return __generator(this, function (_a) {
                Ray.lockCounter++;
                lockName = md5("".concat(new Date().getTime(), "-").concat(Ray.lockCounter));
                payload = new CreateLockPayload(lockName);
                this.sendRequest(payload);
                return [2, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var exists, err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    sleep(1);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4, Ray.client.lockExists(lockName)];
                                case 2:
                                    exists = _a.sent();
                                    return [3, 4];
                                case 3:
                                    err_1 = _a.sent();
                                    reject(err_1);
                                    return [2, false];
                                case 4:
                                    if (exists !== true && exists && exists.stop_execution) {
                                        reject(false);
                                        return [2, false];
                                    }
                                    _a.label = 5;
                                case 5:
                                    if (exists.active) return [3, 0];
                                    _a.label = 6;
                                case 6:
                                    resolve(this);
                                    return [2];
                            }
                        });
                    }); })];
            });
        });
    };
    Ray.prototype.stopTime = function (stopwatchName) {
        if (stopwatchName === void 0) { stopwatchName = ''; }
        if (stopwatchName === '') {
            Ray.stopWatches = {};
            return this;
        }
        if (typeof Ray.stopWatches[stopwatchName] !== 'undefined') {
            delete Ray.stopWatches[stopwatchName];
        }
        return this;
    };
    Ray.prototype.caller = function () {
        var backtrace = StackTrace.getSync();
        var payload = new CallerPayload(backtrace);
        return this.sendRequest(payload);
    };
    Ray.prototype.trace = function () {
        var backtrace = StackTrace.getSync();
        var payload = new TracePayload(backtrace);
        return this.sendRequest(payload);
    };
    Ray.prototype.measure = function (stopwatchName) {
        if (stopwatchName === void 0) { stopwatchName = 'default'; }
        if (stopwatchName instanceof Function) {
            return this.measureClosure(stopwatchName);
        }
        if (typeof Ray.stopWatches[stopwatchName] === 'undefined') {
            var stopwatch_1 = this.getStopwatch(stopwatchName);
            Ray.stopWatches[stopwatchName] = stopwatch_1;
            var event_1 = stopwatch_1.start(stopwatchName);
            var payload_1 = this.getMeasurePayload(stopwatchName, event_1);
            payload_1.concernsNewTimer();
            return this.sendRequest(payload_1);
        }
        var stopwatch = Ray.stopWatches[stopwatchName];
        var event = stopwatch.lap();
        var payload = this.getMeasurePayload(stopwatchName, event);
        return this.sendRequest(payload);
    };
    Ray.prototype.measureClosure = function (closure) {
        var stopwatch = this.getStopwatch('closure');
        stopwatch.start('closure');
        closure();
        var event = stopwatch.stop();
        var payload = this.getMeasurePayload('closure', event);
        return this.sendRequest(payload);
    };
    Ray.prototype.getStopwatch = function (name) {
        return new Stopwatch(name);
    };
    Ray.prototype.getMeasurePayload = function (name, event) {
        return new MeasurePayload(name, event);
    };
    Ray.prototype.separator = function () {
        var payload = new SeparatorPayload();
        return this.sendRequest(payload);
    };
    Ray.prototype.xml = function (xml) {
        var payload = new XmlPayload(xml);
        return this.sendRequest(payload);
    };
    Ray.prototype.html = function (html) {
        if (html === void 0) { html = ''; }
        var payload = new HtmlPayload(html);
        return this.sendRequest(payload);
    };
    Ray.prototype.text = function (text) {
        if (text === void 0) { text = ''; }
        var payload = new TextPayload(text);
        return this.sendRequest(payload);
    };
    Ray.prototype.date = function (date) {
        var payload = new DatePayload(date);
        return this.sendRequest(payload);
    };
    Ray.prototype.raw = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!args.length) {
            return this;
        }
        var payloads = args.map(function (arg) { return LogPayload.createForArguments([arg]); });
        return this.sendRequest(payloads);
    };
    Ray.prototype.send = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!args.length) {
            return this;
        }
        if (this.settings.always_send_raw_values) {
            return this.raw.apply(this, args);
        }
        var payloads = PayloadFactory.createForValues(args);
        return this.sendRequest(payloads);
    };
    Ray.prototype.pass = function (argument) {
        this.send(argument);
        return argument;
    };
    Ray.prototype.showApp = function () {
        var payload = new ShowAppPayload();
        return this.sendRequest(payload);
    };
    Ray.prototype.hideApp = function () {
        var payload = new HideAppPayload();
        return this.sendRequest(payload);
    };
    Ray.prototype.macro = function (name, handler) {
        Ray.macros[name] = handler;
        this[name] = handler.bind(this);
        return this;
    };
    Ray.prototype.htmlMarkup = function (html, options) {
        if (options === void 0) { options = {}; }
        var payload = new HtmlMarkupPayload(html, options);
        return this.sendRequest(payload);
    };
    Ray.prototype.if = function (boolOrCallable, callback) {
        if (callback === void 0) { callback = null; }
        if (typeof boolOrCallable === 'function') {
            boolOrCallable = boolOrCallable();
        }
        if (boolOrCallable && callback !== null) {
            callback(this);
        }
        if (callback === null) {
            this.canSendPayload = boolOrCallable;
        }
        return this;
    };
    Ray.prototype.limit = function (count) {
        var frame = this.getOriginFrame();
        this.limitOrigin = {
            function_name: frame === null || frame === void 0 ? void 0 : frame.getFunctionName(),
            file: frame === null || frame === void 0 ? void 0 : frame.getFileName(),
            line_number: frame === null || frame === void 0 ? void 0 : frame.getLineNumber(),
            hostname: Hostname.get(),
        };
        Ray.limiters.initialize(this.limitOrigin, count);
        return this;
    };
    Ray.prototype.once = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var frame = this.getOriginFrame();
        this.limitOrigin = {
            function_name: frame === null || frame === void 0 ? void 0 : frame.getFunctionName(),
            file: frame === null || frame === void 0 ? void 0 : frame.getFileName(),
            line_number: frame === null || frame === void 0 ? void 0 : frame.getLineNumber(),
            hostname: Hostname.get(),
        };
        Ray.limiters.initialize(this.limitOrigin, 1);
        if (args.length > 0) {
            return this.send.apply(this, args);
        }
        return this;
    };
    Ray.prototype.sendCustom = function (content, label) {
        if (label === void 0) { label = ''; }
        var payload = new CustomPayload(content, label);
        return this.sendRequest(payload);
    };
    Ray.prototype.getOriginFrame = function () {
        var st = StackTrace.getSync();
        var startFrameIndex = st.findIndex(function (frame) { var _a; return (_a = frame.functionName) === null || _a === void 0 ? void 0 : _a.includes('Ray.sendRequest'); });
        if (startFrameIndex === -1) {
            startFrameIndex = 0;
        }
        var callerFrames = RemovesRayFrames.removeRayFrames(st.slice(startFrameIndex).filter(function (frame) { var _a; return !((_a = frame.functionName) === null || _a === void 0 ? void 0 : _a.includes('Ray.')); }));
        return callerFrames.slice(0).shift();
    };
    Ray.prototype.getCaller = function () {
        var st = StackTrace.getSync();
        var startFrameIndex = st.findIndex(function (frame) { var _a; return (_a = frame.functionName) === null || _a === void 0 ? void 0 : _a.includes('Ray.getCaller'); });
        if (startFrameIndex === -1) {
            startFrameIndex = 0;
        }
        var callerFrames = st.slice(startFrameIndex);
        if (callerFrames.length === 1) {
            return callerFrames.shift();
        }
        return callerFrames.slice(2).shift();
    };
    Ray.prototype.getOriginData = function () {
        var frame = this.getOriginFrame();
        return {
            function_name: frame === null || frame === void 0 ? void 0 : frame.getFunctionName(),
            file: frame === null || frame === void 0 ? void 0 : frame.getFileName(),
            line_number: frame === null || frame === void 0 ? void 0 : frame.getLineNumber(),
            hostname: Hostname.get(),
        };
    };
    Ray.prototype.sendRequest = function (payloads, meta) {
        var _this = this;
        var _a;
        if (meta === void 0) { meta = []; }
        if (!this.enabled()) {
            return this;
        }
        if (!this.canSendPayload) {
            return this;
        }
        if (this.limitOrigin !== null) {
            if (!Ray.limiters.canSendPayload(this.limitOrigin)) {
                return this;
            }
            Ray.limiters.increment(this.limitOrigin);
        }
        if (!Array.isArray(payloads)) {
            payloads = [payloads];
        }
        if (this.rateLimiter().isMaxReached() || this.rateLimiter().isMaxPerSecondReached()) {
            this.notifyWhenRateLimitReached();
            return this;
        }
        var allMeta = Object.assign({}, {
            node_ray_package_version: PACKAGE_VERSION,
            project_name: Ray.projectName,
        }, meta);
        payloads.forEach(function (payload) {
            payload.data.origin = _this.getOriginData();
            payload.remotePath = _this.settings.remote_path;
            payload.localPath = _this.settings.local_path;
        });
        if (this.settings.sending_payload_callback !== null && !this.inCallback) {
            this.inCallback = true;
            this.settings.sending_payload_callback(new Ray(this.settings, this.client(), this.uuid, true), payloads);
            this.inCallback = false;
        }
        var request = new Request(this.uuid, payloads, allMeta);
        (_a = Ray.client) === null || _a === void 0 ? void 0 : _a.send(request);
        this.rateLimiter().hit();
        if (this.settings.sent_payload_callback !== null && !this.inCallback) {
            this.inCallback = true;
            this.settings.sent_payload_callback(this);
            this.inCallback = false;
        }
        return this;
    };
    Ray.prototype.rateLimiter = function () {
        return Ray._rateLimiter;
    };
    Ray.prototype.notifyWhenRateLimitReached = function () {
        if (this.rateLimiter().isNotified()) {
            return;
        }
        var customPayload = new CustomPayload('Rate limit has been reached...', 'Rate limit');
        var request = new Request(this.uuid, [customPayload], []);
        Ray.client.send(request);
        this.rateLimiter().notify();
    };
    Ray.lockCounter = 0;
    Ray.defaultSettings = { not_defined: true };
    Ray.projectName = '';
    Ray.counters = new Counters();
    Ray.limiters = new Limiters();
    Ray.interceptor = new ConsoleInterceptor();
    Ray.stopWatches = {};
    Ray.enabled = null;
    Ray.macros = {};
    Ray._rateLimiter = RateLimiter.disabled();
    return Ray;
}(Mixin(RayColors, RaySizes)));
var ray = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = Ray.create()).send.apply(_a, args);
};

exports.Ray = Ray;
exports.ray = ray;
